import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import App from "./App";
import { AuthProvider } from "./auth/AuthProvider";
import "./index.css";

const qc = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      // Real-time: refetch mỗi 15s khi tab active, + khi focus, + nếu mutation invalidate.
      refetchOnWindowFocus: true,
      refetchOnMount: "always",
      refetchInterval: 15_000,
      refetchIntervalInBackground: false,
      staleTime: 0, // luôn coi dữ liệu cũ → mỗi mount sẽ refetch
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={qc}>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
